import { combineReducers } from "redux";
import informationusers from "./informationusers";
import clientdetails from "./clientdetails";
import ivrcalltransfer from "./ivrcalltransfer";
import agents from "./agents";
import servicesidlogin from "./servicesidlogin";
import opcoes from "./opcoes";
import reasonsblock from "./reasonsblock";
import messages from "./messages";
import messagesheader from "./messagesheader";
import atendimento from "./atendimento";
import uploadfile from "./uploadfile";
import status from "./status";
import blockfuture from "./blockfuture";
import timestatus from "./timestatus";
import displaydetailsatd from "./displaydetailsatd";
import showactivecall from "./showactivecall";
import ipcurrent from "./ipcurrent";
import listcallqueue from "./listqueue";
import queuepermission from "./queuepermission";
import history from "./history";
import respostas from "./respostas";
import detailsanotations from "./detailsanotations";
import groups from "./groups";
import criticalitys from "./criticalitys";
import routergroups from "./routergroups";
import outservices from "./outservices";
import displaynextatd from "./displaynextatd";
import detailsmarkstars from "./detailsmarkstars";
import detailsfileshared from "./detailsfileshared";
import atdsimult from "./atdsimult";
import historycalls from "./historycalls";
import typing from "./typing";
import infodisplay from "./infodisplay";
import notifications from "./notifications";
import servicegroup from "./servicegroup";
import listsupgroup from "./listsupgroup";
import cep from "./cep";
import displaynextgroup from "./displaynextgroup";
import modals from "./modals";
import contacts from "./contacts";
import companys from "./companys";
import numberscontact from "./numberscontact";
import typenumbers from "./typenumbers";
import midias from "./midias";
import interactions from "./interactions";
import servicoagrupado from "./servicoagrupado";
import chatinternal from "./chatinternal";
import chatsimult from "./chatsimult";
import monitoringsimult from "./monitoringsimult";
import registernotifier from "./registernotifier";
import currentscreen from "./currentscreen";
import capturequeue from "./capturequeue";
import connectionsapi from "./connectionsapi";
import monitoring from "./monitoring";
import clientusermonitors from "./clientusermonitors";
import phonemidia from "./phonemidia";
import gravacaovoz from "./gravacaovoz";
import filters from "./filters";
import infocontact from "./infocontact";
import automaticpause from "./automaticpause";
import listgroupmsg from "./listgroupmsg";
import conferencia from "./conferencia";
import serviceurl from "./serviceurl";
import listdevice from "./listdevice";
import listdevicedefault from "./listdevicedefault";
import reasonsblocksup from "./reasonsblocksup";
import interactioningdesk from "./interactioningdesk";
import messagemail from "./messagemail";
import mimetypes from "./mimetypes";
import tabulator from "./tabulator";
import columnsmail from "./columnsmail";
import columnsallservices from "./columnsallservices";
import columnsallcolaborators from "./columnsallcolaborators";
import columnsalloperators from "./columnsalloperators";
import datamanagernpscsat from "./datamanagernpscsat";
import datamanagerstatusoperators from "./datamanagerstatusoperators";
import grouppermissionsupervisor from "./grouppermissionsupervisor";
import datamanagerintentions from "./datamanagerintentions";
import filtersmanager from "./filtersmanager";
import datamanagerperfomance from "./datamanagerperfomance";
import devices from "./devices";
import callpark from "./callpark";
import activeheader from "./activeheader";
import interactionsmodal from "./interactivemodal";
import detailscontacts from "./detailscontacts";
import npsfilters from "./npsfilters";
import npsdetails from "./npsdetails";
import answerhidden from "./answerhidden";
import columnsgrouprow from "./columnsgrouprow";
import groupsrow from "./groupsrow";
import columnsDealing from "./columnsDealing";
import agentDashboardFilter from "./agentDashboardFilter";
import columnsDealingAgent from "./columnsDealingAgent";
import columnsNegotiationsAgent from "./columnsNegotiationsAgent";
import cardsOfCallCenterDash from "./cardsOfCallCenterDash";
import cardsOfCallCenterIndicators from "./cardsOfCallCenterIndicators";
import isSideContentOpen from "./isSideContentOpen";
import sideContentAttendanceSelected from "./sideContentSelected";
import messageFromHelpSideContent from "./messageFromHelpSideContent";
import isLoadingSideContent from "./isLoadingSideContent";
import ingFaqConditions from "./ingFaqConditions";
import listQuarentineQueue from "./listQuarentineQueue";
import infosToSendToQuarentine from "./infosToSendToQuarentine";
import dateOfFilterQuarentine from "./dateOfFilterQuarentine";
import queueTabActive from "./queueTabActive";
import isReconnectModalActive from "./isReconnectModalActive";
import tmnoreplyPerAgent from "./tmnoreplyPerAgent";
import routerGroupGroupedByMidiaId from "./routerGroupGroupedByMidiaId";
import selectedChatMonitoring from "./selectedChatMonitoring";
import isOpenFaqDragableReducer from "./isOpenFaqDragable";
import filtrosDeFila from "./filtrosDeFila";
import disableStandByButton from "./disableStandByButton";

export default combineReducers({
  opcoes,
  informationusers,
  clientdetails,
  agents,
  servicesidlogin,
  typenumbers,
  ivrcalltransfer,
  reasonsblock,
  messages,
  messagesheader,
  status,
  blockfuture,
  timestatus,
  displaydetailsatd,
  atendimento,
  uploadfile,
  ipcurrent,
  listcallqueue,
  queuepermission,
  respostas,
  detailsanotations,
  groups,
  history,
  criticalitys,
  routergroups,
  outservices,
  showactivecall,
  displaynextatd,
  detailsmarkstars,
  detailsfileshared,
  atdsimult,
  historycalls,
  infodisplay,
  notifications,
  typing,
  servicegroup,
  listsupgroup,
  modals,
  contacts,
  numberscontact,
  companys,
  cep,
  midias,
  servicoagrupado,
  displaynextgroup,
  interactions,
  chatinternal,
  chatsimult,
  registernotifier,
  currentscreen,
  capturequeue,
  connectionsapi,
  monitoringsimult,
  monitoring,
  clientusermonitors,
  phonemidia,
  gravacaovoz,
  filters,
  infocontact,
  automaticpause,
  listgroupmsg,
  conferencia,
  serviceurl,
  listdevice,
  listdevicedefault,
  reasonsblocksup,
  interactioningdesk,
  messagemail,
  mimetypes,
  tabulator,
  columnsmail,
  columnsallservices,
  columnsallcolaborators,
  datamanagernpscsat,
  datamanagerstatusoperators,
  grouppermissionsupervisor,
  datamanagerintentions,
  filtersmanager,
  datamanagerperfomance,
  devices,
  callpark,
  activeheader,
  interactionsmodal,
  detailscontacts,
  columnsalloperators,
  npsfilters,
  npsdetails,
  answerhidden,
  columnsgrouprow,
  groupsrow,
  columnsDealing,
  agentDashboardFilter,
  columnsDealingAgent,
  columnsNegotiationsAgent,
  cardsOfCallCenterDash,
  cardsOfCallCenterIndicators,
  isSideContentOpen,
  sideContentAttendanceSelected,
  messageFromHelpSideContent,
  isLoadingSideContent,
  ingFaqConditions,
  listQuarentineQueue,
  infosToSendToQuarentine,
  dateOfFilterQuarentine,
  queueTabActive,
  isReconnectModalActive,
  tmnoreplyPerAgent,
  routerGroupGroupedByMidiaId,
  selectedChatMonitoring,
  isOpenFaqDragableReducer,
  filtrosDeFila,
  disableStandByButton,
});
